import React from 'react';
import { X, History, UserPlus, UserX, Check, Eye } from 'lucide-react';

const ChatLogSheet = ({ isOpen, onClose, chatLog, strangerName, onAddFriend, onIgnore, _onPass, status }) => {
  if (!isOpen) return null;

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', hour12: false });
  };

  return (
    <div className="fixed inset-0 z-[110] bg-black/50" onClick={onClose}>
      <div 
        className="fixed inset-x-0 bottom-0 glass-card rounded-t-[40px] h-[80vh] flex flex-col page-enter safe-bottom border-b-0 shadow-[0_-10px_60px_rgba(0,0,0,0.8)]"
        onClick={e => e.stopPropagation()}
      >
        <div className="p-6 border-b border-white/5 flex justify-between items-center">
          <div>
            <h3 className="text-xl font-bold flex items-center gap-3 text-white">
              <History size={24} className="text-[var(--neon-primary)]" />
              对话记录
            </h3>
            <p className="text-xs text-gray-400 mt-1">
              {strangerName} 与您的分身对话了 {chatLog?.length || 0} 轮
            </p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full">
            <X size={24} className="text-white/60" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6 space-y-4">
          {(!chatLog || chatLog.length === 0) && (
            <div className="text-center text-gray-500 py-10">
              <p>暂无对话记录</p>
            </div>
          )}
          
          {chatLog?.map((msg, index) => (
            <div key={msg.id || index} className={`flex ${msg.sender === 'me' ? 'justify-start' : 'justify-end'}`}>
              <div className={`max-w-[80%] px-5 py-3 rounded-2xl text-sm ${
                msg.sender === 'me' 
                  ? 'bg-white/5 text-gray-200 border border-white/5' 
                  : 'bg-[var(--neon-primary)]/10 text-cyan-100 border border-[var(--neon-primary)]/20'
              }`}>
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[10px] opacity-50 font-mono uppercase">
                    {msg.sender === 'me' ? strangerName : '您的分身'}
                  </span>
                  <span className="text-[10px] opacity-30">
                    {formatTime(msg.timestamp)}
                  </span>
                </div>
                <p>{msg.text}</p>
              </div>
            </div>
          ))}
        </div>

        {status === 'pending' && (
          <div className="p-6 space-y-3 safe-bottom bg-black/20">
            <button 
              onClick={() => {}}
              className="w-full py-3 bg-white/5 rounded-2xl text-sm font-medium text-gray-300 hover:bg-white/10 transition-colors border border-white/5 flex items-center justify-center gap-2"
            >
              <Eye size={18} />
              查看对话
            </button>
            <div className="flex gap-3">
              <button 
                onClick={onIgnore}
                className="flex-1 py-4 bg-white/5 rounded-2xl text-sm font-bold text-white/70 hover:bg-white/10 hover:text-white transition-colors border border-white/5 flex items-center justify-center gap-2"
              >
                <UserX size={18} />
                忽略
              </button>
              <button 
                onClick={onAddFriend}
                className="flex-1 py-4 bg-gradient-to-r from-[var(--neon-primary)] to-blue-600 rounded-2xl text-sm font-bold text-black shadow-[0_0_20px_rgba(0,242,234,0.3)] hover:scale-[1.02] transition-transform flex items-center justify-center gap-2"
              >
                <UserPlus size={18} />
                通过申请
              </button>
            </div>
          </div>
        )}

        {status === 'viewed' && (
          <div className="p-6 space-y-3 safe-bottom bg-black/20">
            <p className="text-center text-sm text-gray-400 mb-3">
              是否要将对方加为好友？
            </p>
            <div className="flex gap-3">
              <button 
                onClick={onIgnore}
                className="flex-1 py-4 bg-white/5 rounded-2xl text-sm font-bold text-white/70 hover:bg-white/10 transition-colors border border-white/5"
              >
                忽略
              </button>
              <button 
                onClick={onAddFriend}
                className="flex-1 py-4 bg-gradient-to-r from-[var(--neon-primary)] to-blue-600 rounded-2xl text-sm font-bold text-black shadow-[0_0_20px_rgba(0,242,234,0.3)] hover:scale-[1.02] transition-transform"
              >
                加为好友
              </button>
            </div>
          </div>
        )}

        {status === 'ignored' && (
          <div className="p-6 safe-bottom bg-black/20">
            <div className="w-full py-4 bg-gray-700/50 rounded-2xl text-sm font-bold text-gray-400 text-center flex items-center justify-center gap-2">
              <Check size={18} />
              已忽略
            </div>
          </div>
        )}

        {status === 'accepted' && (
          <div className="p-6 safe-bottom bg-black/20">
            <div className="w-full py-4 bg-emerald-500/20 rounded-2xl text-sm font-bold text-emerald-400 text-center flex items-center justify-center gap-2 border border-emerald-500/30">
              <Check size={18} />
              已成为好友
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatLogSheet;
